import {
  isAbGroup,
  isBasicGroup,
  isGroup,
  isLoopAndMergeGroup,
} from 'utils/nodeTypes';

export function isGroupNodeSupportsFeatures(type) {
  return (
    isGroup(type) &&
    (isBasicGroup(type) || isAbGroup(type) || isLoopAndMergeGroup(type))
  );
}
